<template>
  <select-dialog
    :title="$t('CargoMsg.Cargo_SelectSpecificBusinessRule')"
    :row-data="rowData"
    :column-defs="columnDefs"
    :filter-keys="['ruleName']"
    :value="specificBusinessRuleUuid"
    :event-name="eventName"
    :input-width="inputWidth"
    display-name-field="ruleName"
    @change="changeTrigger"
  />
</template>

<script>
import { SE } from '@/class/cargo/model/parameters/SystemConstants'
import {
  querySpecificBusinessRuleByTenant
} from '@/api/sysManage/baseConfig/instruction'
import SelectDialog from '@/components/SelectDialog'
import { sleep } from '@/utils/commonUtil'
export default {
  name: 'SpecificBusinessRuleDialog',
  components: { SelectDialog },
  props: {
    lob: {
      type: String,
      default: () => SE.code
    },
    applyUiCustom: { type: Boolean, default: false }, // 是否应用于UI自定义
    applySopBoard: { type: Boolean, default: false }, // 是否应用于SOP面板
    applySopStateTrigger: { type: Boolean, default: false }, // 是否应用于SOP状态触发
    specificBusinessRuleUuid: {
      type: String,
      default: () => ''
    },
    specificBusinessRules: { type: Array, default: () => [] }, // 特定业务规则
    inputWidth: {
      type: String,
      default: '250px'
    }
  },
  data() {
    return {
      rowData: [],
      columnDefs: [
        {
          headerName: this.$t('SystemMaintenance.RuleName'),
          field: 'ruleName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_RuleCode'),
          field: 'ruleCode',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CodeParameterValues'),
          field: 'codeParamDescription',
          width: 200
        }, {
          headerName: this.$t('SeaExport.descr'),
          field: 'remark',
          width: 200
        }
      ],
      eventName: ''
    }
  },
  watch: {
    specificBusinessRuleUuid(newValue, preValue) {
      this.eventName = ''
      if (this.rowData && this.rowData.length > 0 && this.specificBusinessRuleUuid) {
        const specificBusinessRule = this.rowData.find(item => item.uuid === this.specificBusinessRuleUuid)
        if (specificBusinessRule) {
          this.eventName = specificBusinessRule.ruleName
        }
      }
    }
  },
  created() {
    this.rowData = []
    this.eventName = ''
    if (this.specificBusinessRules && this.specificBusinessRules.length > 0) {
      this.rowData = this.specificBusinessRules.filter(p => this.matchLob(this.lob, p.lob) && ((this.applyUiCustom && p.isApplyUiCustom) || (this.applySopBoard && p.isApplySopBoard) || (this.applySopStateTrigger && p.isApplySopStateTrigger)))
      if (this.rowData && this.rowData.length > 0 && this.specificBusinessRuleUuid) {
        const specificBusinessRule = this.rowData.find(item => item.uuid === this.specificBusinessRuleUuid)
        if (specificBusinessRule) {
          this.eventName = specificBusinessRule.ruleName
        }
      }
    }
  },
  methods: {
    changeTrigger(data) {
      this.$emit('change', data)
    },
    // 匹配业务类型
    matchLob(singleLob, multipleLob) {
      singleLob = singleLob || ''
      multipleLob = multipleLob || ''
      const lobs = multipleLob.split(',')
      return lobs.includes(singleLob)
    }
  }
}
</script>
